import React from 'react';
import InfoTooltip from '../../info-tooltip/info-tooltip';
import { MeetingTimeZoneHelper } from '../../../utils/meetingTimeZoneHelper';

interface MeetingStartTimeProps {
    dateStart: Date | string;
    dateEnd: Date | string;
    /** The zone the meeting was scheduled in, e.g. 'CDT'. */
    timeZone?: string | null;
    /** Unique per tile, e.g. `${meeting.id}-start`. */
    tooltipKey: string;
}

/**
 * A meeting's start time in the viewer's zone with that zone named, e.g. '10:00 AM EDT'. When the viewer
 * sees it in another zone than the one the meeting was scheduled in, an info icon next to it shows the
 * scheduled time, e.g. 'Scheduled for 10/06/2026 10:00 AM – 11:00 AM CDT'.
 */
export const MeetingStartTime = (props: MeetingStartTimeProps) => {
    const note = MeetingTimeZoneHelper.getScheduledTimeNote(
        props.dateStart,
        props.dateEnd,
        props.timeZone
    );

    return (
        <>
            {MeetingTimeZoneHelper.formatTime(props.dateStart)}
            {note && (
                <InfoTooltip
                    text={note}
                    idText={`meeting-start-${props.tooltipKey}`}
                    place="top"
                />
            )}
        </>
    );
};
